import React from 'react';

type Iprops = {
    pClassName?: string
    onLogo?: (e?: any) => void
}

function Logo(props: Iprops) {
  const {
    onLogo,
    pClassName
  } = props
  return (
    <div className={`flex items-center justify-start pt-[20px] ${pClassName}`}>
        <img
          alt='empty'
          onClick={onLogo}
          src={require('../../../img/logo_blue.webp')}
          className=' h-[45px] cursor-pointer'
        />
    </div>
  );
}

export default Logo;
